<template>
    <LoginContent>
        <div class="row justify-content-center">
            <div class="col-12 col-lg-8 col-xl-5">
                <div class="min-height-100vh has-header d-flex align-items-center">
                    <div class="form-content form-team-content w-100 white-content">
                        <div class="h1 mb-4 text-center text-uppercase">{{ $t('login.registro_titulo') }}</div>
                        <div class="thumb-container absolute" :style='"background-image: url(" + footer.logo + ")"'></div>
                        <ValidationObserver ref="observer" v-slot="{ invalid }">
                            <form class="w-100" @submit.prevent="register">
                                <div class="form-group">
                                    <label for="name">{{ $t('formularios.nombre') }}</label>
                                    <ValidationProvider name="name" rules="required" v-slot="{ errors }">
                                        <input type="text" name="name" id="name" v-model="login_data.name" />
                                        <span class="error" v-if="errors[0]">{{ errors[0] }}</span>
                                        <span class="error" v-if="errores.name">{{ errores.name[0] }}</span>
                                    </ValidationProvider>
                                </div>

                                <div class="form-group">
                                    <label for="surnames">{{ $t('formularios.apellidos') }}</label>
                                    <ValidationProvider name="surnames" rules="required" v-slot="{ errors }">
                                        <input type="text" name="surnames" id="surnames" v-model="login_data.surnames" />
                                        <span class="error" v-if="errors[0]">{{ errors[0] }}</span>
                                        <span class="error" v-if="errores.surnames">{{ errores.surnames[0] }}</span>
                                    </ValidationProvider>
                                </div>

                                <div class="form-group">
                                    <label for="email">{{ $t('formularios.email') }}</label>
                                    <ValidationProvider name="email" rules="required|email" v-slot="{ errors }">
                                        <input type="text" name="email" id="email" v-model="login_data.email"/>
                                        <span class="error" v-if="errors[0]">{{ errors[0] }}</span>
                                        <span class="error" v-if="errores.email">{{ errores.email[0] }}</span>
                                    </ValidationProvider>
                                </div>

                                <div class="form-group">
                                    <label for="password">{{ $t('formularios.password') }}</label>
                                    <ValidationProvider name="password" rules="required|min:6" v-slot="{ errors }">
                                        <input type="password" name="password" id="password" v-model="login_data.password"/>
                                        <span class="error" v-if="errors[0]">{{ errors[0] }}</span>
                                        <span class="error" v-if="errores.password">{{ errores.password[0] }}</span>
                                    </ValidationProvider>
                                </div>
                                
                                <div class="form-group">
                                    <label for="password_confirmation">{{ $t('formularios.confirmar_password') }}</label>
                                    <ValidationProvider
                                        name="password_confirmation"
                                        rules="required|confirmed:password"
                                        v-slot="{ errors }"
                                    >
                                        <input type="password" name="password_confirmation" id="password_confirmation" v-model="login_data.password_confirmation"/>
                                        <span class="error" v-if="errors[0]">Las contraseñas no coinciden </span>
                                        <span class="error" v-if="errores.password_confirmation">{{ errores.password_confirmation[0] }}</span>
                                    </ValidationProvider>
                                </div>

                                <div class="row justify-content-md-between">
                                    <div class="col-12 col-lg-6">
                                        <button type="submit" class="button" name="button" :disabled="invalid">{{ $t('login.enviar') }}</button>
                                    </div>
                                    <div class="col-12">
                                        <p class="forgot recupera_texto">
                                            <router-link :to="{ name: 'login' }" class="text-underline text-bold">
                                                <small>{{ $t('login.vuelta_login') }}</small>
                                            </router-link>
                                        </p>
                                    </div>
                                </div>
                            </form>
                        </ValidationObserver>
                    </div>
                </div>
            </div>
        </div>
    </LoginContent>
</template>

<script>
    import LoginContent from '@/components/frontend/components/LoginContent';

    export default {
        data() {
            return {
                login_data: {
                    name: '',
                    surnames: '',
                    email: '',
                    password: '',
                    password_confirmation: ''
                },
                mensaje: null,
                errores: {}
            }
        },
        computed: {
            configuracion() {
                return this.$store.getters.getConfig;
            },
            footer() {
                return this.$store.getters.getFooter;
            }
        },
        methods: {
            async register() {
                this.errores = {};
                this.mensaje = null;

                const valid = await this.$refs.observer.validate();
                if (!valid) return;

                this.login_data.filters = {
                    tid: this.configuracion.hash_teatro
                };

                this.$store.dispatch(this.config.getVuexAlias('register'), this.login_data)
                    .then(res => {
                        this.$toast.success("Usuario registrado correctamente");
                        this.$router.push({ name: 'perfil' });
                    })
                    .catch(error => {
                        if (error.response && error.response.data && error.response.data.errors) {
                            this.errores = error.response.data.errors;
                        } else {
                            this.$toast.error("Error al registrar usuario");

                        }
                    });
            }
        },
        components: {
            LoginContent
        }
    }
</script>

<style scoped>
    .recupera_texto {
        text-align: right;
    }

    @media (max-width: 768px)  {
        .recupera_texto {
        align-items: center;
        justify-content: center;
        text-align: center;
        margin: 1em;
        }
    }
</style>